<template>
  <v-ons-page id="company-info-page" class="option2 page-column">
    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button>
        </v-ons-back-button>
      </div>
      <div class="center">Company Info</div>
    </v-ons-toolbar>

    <div class="flex-column flex-grow">
      <div style="width: 100%">
        <v-ons-card
          v-for="(item, $index) in pages"
          @click="push(item.page, item.filter)"
          :key="$index">
          <div class="title">
            <span>{{ item.label }}</span>
          </div>
        </v-ons-card>
      </div>
    </div>

  </v-ons-page>
</template>

<script>
import ContactCards from '../../components/ContactCards.vue'
import Legal from '../../components/Legal.vue'
import CompanyHistory from '../../components/CompanyHistory.vue'
import { appData } from '../../data.js'

export default {
  name: 'company-info',
  data () {
    return {
      showUpdateAlert: false,
      pages: [
        {
          label: 'Company History',
          page: CompanyHistory
        },
        {
          label: 'Company Directory',
          page: ContactCards,
          filter: 'IsCompany'
        },
        {
          label: 'Legal',
          page: Legal
        },
      ]
    }
  },
  methods: {
    push(page, filter) {
      this.$emit('push-page', {
        extends: page,
        onsNavigatorProps: {
          employees: appData.state.employees.filter(e => e[filter]),
          sales: filter === 'IsSales'
        }
      });
    }
  },
  created() {

  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
    flex: none;
  }

  .header img {
    display: block;
    max-width: 300px;
    max-height: 100px;
    height: auto;
    width: auto;
  }

  ons-list-title {
    text-transform: none;
  }

  ons-list-title:not(:first-of-type) {
    margin-top: 30px;
  }

  ons-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding: 6px;
  }

  ons-card img {
    width: 100%;
  }

  ons-card > * {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/Option2/components/CompanyInfo.vue